import React from 'react';

const Home = React.lazy(() => import('./containers/Home/Home'));
const Benefits = React.lazy(() => import('./containers/Benefits/Benefits'));
const Care = React.lazy(() => import('./containers/Care/Care'));
const Scheduling = React.lazy(() => import('./containers/Scheduling/Scheduling'));
const Resources = React.lazy(() => import('./containers/Resources/Resources'));
const Employer = React.lazy(() => import('./containers/Employer/Employer'));
const Interstitial = React.lazy(() => import('./containers/Interstitial/Interstitial'));

const routes = [
	{ path: '/', exact: true, name: 'Home', component: Home },
	{ path: '/benefits', exact: true, name: 'Benefits', component: Benefits },
	{ path: '/getCare', exact: true, name: 'Care', component: Care },
	{ path: '/openScheduling', exact: true, name: 'Scheduling', component: Scheduling },
	{ path: '/resources', exact: true, name: 'Resources', component: Resources },
	{ path: '/interstitial', exact: true, name: 'Interstitial', component: Interstitial },
	{ path: '/employerContent', exact: true, name: 'Employer', component: Employer },
];

export default routes;
